<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <p>
                RSE Newcastle 2020 in conjunction with the School of Arts and Cultures (HASS)
            </p>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "AppFooter"
    }
</script>

<style scoped>

  .footer {
    padding: 20px;
  }

</style>
